$(document).ready(function () {
    const tableEl = $('#stock-transactions-table');
    if (!tableEl.length) return;

    const dataTable = tableEl.DataTable({
        processing: true,
        serverSide: true,
        pageLength: 25,
        searchDelay: 350,
        order: [],
        lengthMenu: [[10, 25, 50, 100], [10, 25, 50, 100]],
        ajax: {
            url: tableEl.data('url'),
            data: function (d) {
                const form = $('#stock-transactions-filters');
                if (form.length) {
                    form.serializeArray().forEach(function (field) {
                        if (d[field.name] === undefined) d[field.name] = field.value;
                        else if (Array.isArray(d[field.name])) d[field.name].push(field.value);
                        else d[field.name] = [d[field.name], field.value];
                    });
                }
            }
        },
        columns: [
            { data: 'id', name: 'id' },
            { data: 'effective_date', name: 'effective_date' },
            { data: 'type', name: 'type' },
            { data: 'status', name: 'status' },
            { data: 'properties', name: 'properties', orderable: false, searchable: false },
            { data: 'items', name: 'items' },
            { data: 'comment', name: 'comment', orderable: false },
            { data: 'actions', name: 'actions', orderable: false, searchable: false }
        ],
        language: window.dataTablesRussianLanguage
    });

    const form = $('#stock-transactions-filters');
    if (form.length) {
        form.on('submit', function (e) {
            e.preventDefault();
            dataTable.page('first').draw('page');
        });
        form.on('changed.bs.select change', 'select, input[type="date"]', function () { dataTable.page('first').draw('page'); });
        form.on('click', '.js-table-reset', function () {
            form[0].reset(); form.find('.selectpicker').selectpicker('refresh');
            dataTable.search('').order([1, 'desc']).page('first').draw();
        });
    }
});
